import { render } from "./EditDealerArea.vue?vue&type=template&id=328dcf1b"
import script from "./EditDealerArea.vue?vue&type=script&lang=js"
export * from "./EditDealerArea.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__